module.exports = __webpack_public_path__ + "img/pro_rcfw1.fc65399b.png";